import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd }               from '@angular/router';
import { Location }                     from '@angular/common';

import { DragulaService }               from 'ng2-dragula';

import { FieldManualService }           from '../../field-manual.service';
import { FieldManual }                  from './../../../../models/program/field-manual';

@Component({
  selector: 'app-field-manuals',
  templateUrl: './field-manuals.component.html',
  styleUrls: ['./field-manuals.component.less']
})

export class FieldManualsComponent implements OnInit, OnDestroy {
  fms: FieldManual[];

  private sub: any;
  private parentRouteId: number;

  constructor(
    private fieldManualService: FieldManualService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private drag: DragulaService
  ) {
    this.router.events.filter(e => e instanceof NavigationEnd).subscribe((e: NavigationEnd) => {
      let urlArr = e.url.toString().split('/');
      if (urlArr.indexOf('fms') !== -1) {
        this.loadFms();
      }
    });
    drag.drop.subscribe(val => {
      // console.log(val);
      // console.log(this.fms);
      this.reorderFms(this.buildFmIdBody(this.fms));
    });
  }

  ngOnInit(): void {
    this.loadFms();
  }

  private loadFms(): void {
    this.sub = this.route.parent.params.subscribe(params => {
      this.parentRouteId = +params['id'];
    });

    this.fieldManualService
        .getFieldManuals(this.parentRouteId)
        .subscribe(fms => this.fms = fms);
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private buildFmIdBody(fms: FieldManual[]): number[] {
    let ids: number[] = [];
    fms.forEach(fm => ids.push(fm.id));
    return ids;
  }

  private reorderFms(ids: number[]): void {
    this.fieldManualService.reorderFms(this.parentRouteId, { ids: ids });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/field-manuals/field-manuals.component.ts